module.exports = __webpack_public_path__ + "img/step41_down.cff5c18b.png";